module.exports = __webpack_public_path__ + "media/images/pc/reports/main_visual_07-6a20beef42a3d406f397cd715bd74c12.jpg";